import { LIST_PRODUCT } from '../fragments';

const collection = `  
query collection(
  $handle: String
  $first: Int
  $last: Int
  $after: String
  $before: String
  $filters: [ProductFilter!]
  $sortKey: ProductCollectionSortKeys
  $reverse: Boolean
) {
  collection(handle: $handle) {
    id
    handle
    title
    seo {
      title
    }
    products(
      first: $first
      last: $last
      after: $after
      before: $before
      filters: $filters
      sortKey: $sortKey
      reverse: $reverse
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      filters {
        id
        label
        type
        __typename
        values {
          __typename
          id
          input
          label
          count
        }
      }
      edges {
        cursor
        node {
          ${LIST_PRODUCT}
        }
      }
    }
  }
}`;

export default collection;
